export function getIconSizing(idsClassNames: string | undefined): number {
    return idsClassNames?.includes('button') && !idsClassNames?.includes('x-small') ? 24 : 16;
  }